export default function getCsrf() {
    // Detect if user is on IE browser
    const isIE = !!window.MSInputMethodContext && !!document.documentMode;
    const endPoint = '/de-CH/actions/bx-get-csrf-module/site/get-csrf';

    if (isIE) {
        // Create Promise polyfill script tag
        const promiseScript = document.createElement('script');
        promiseScript.type = 'text/javascript';
        promiseScript.src =
            'https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js';

        // Create Fetch polyfill script tag
        const fetchScript = document.createElement('script');
        fetchScript.type = 'text/javascript';
        fetchScript.src =
            'https://cdn.jsdelivr.net/npm/whatwg-fetch@3.4.0/dist/fetch.umd.min.js';

        // Add polyfills to head element
        document.head.appendChild(promiseScript);
        document.head.appendChild(fetchScript);

        // Wait for the polyfills to load and run the function.
        setTimeout(() => {
            return window
                .fetch(endPoint, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache',
                    }
                })
                .then(response => response.json())
                .catch(error => console.warn(error));
        }, 1000);
    } else {
        // If fetch is supported, just run the fetch function
        return fetch(endPoint, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache',
                    }
               })
               .then(response => response.json())
               .catch(error => console.warn(error));
    }
    return false;
}
